export function scrollToId(id: string) {
  const element = document.getElementById(id);

  if (element !== null) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // always return false to prevent default action of anchor tags
  return false;
}
